import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, Output, EventEmitter } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements OnInit, OnChanges {

  @ViewChild("bar", { static: true })
  private _bar: ElementRef;
  @Input() index: any = 0;
  @Input() barData: any;
  @Output() barAction = new EventEmitter<any>();

  private _className: any; 
  constructor() { }

  ngOnInit(): void { } 

  ngOnChanges() {
    if (this.barData.length)
      setTimeout(() => {
        this._plotGraph();
      }, 0);
  }
  private _plotGraph() {
    this._className = 'bar' + JSON.stringify(this.index);
    window.Plotly.newPlot(
      this._bar.nativeElement, //viewchild element
      this.barData, //data provided
      {
        margin: this.barData[0].margin,
        title: this.barData[0].title, //Title of the graph
        hovermode: "closest",
        autosize: true,
        showlegend: this.barData[0].showlegend ? this.barData[0].showlegend : false,
        orientation: this.barData[0]?.orientation,
        yaxis: {
          fixedrange: true,
          tickangle: -45,
          showgrid: this.barData[0].showgrid,
          zeroline: this.barData[0].zeroline,
          visible: this.barData[0].visible,
          showticklabels: this.barData[0].showYticklabels ? this.barData[0].showYticklabels : false,
          rangemode: this.barData[0].rangemode,
          title: this.barData[0]?.yaxisTitle,
          color: '#808080',
          range: this.barData?.[1]?.autorange ? null : [0, this.barData?.[1]?.upperLimit],
          autorange: this.barData?.[1]?.autorange
        },
        xaxis: {
          fixedrange: true,
          range: this.barData[0].range,
          showgrid: this.barData[0].showgrid,
          zeroline: this.barData[0].zeroline,
          visible: this.barData[0].visible,
          showticklabels: this.barData[0].showXticklabels ? this.barData[0].showXticklabels : false,
          color: this.barData[0]?.xaxisTickColor ? this.barData[0]?.xaxisTickColor : '#808080',
          title: {
            text: this.barData[0]?.xaxisTitle,
            font: {
              family: 'Inter',
              size: 12,
              color: '#808080'
            }
          },
        },
        legend: this.barData[0]?.legend,
        barmode: this.barData[0].barmode,
        paper_bgcolor: this.barData[0].barColor ? this.barData[0].barColor : "#f6f6f6",
        plot_bgcolor: this.barData[0].barColor ? this.barData[0].barColor : "#f6f6f6",
        font: {
          size: 10
        },
        bargap: 0,
        bargroupgap: this.barData[0]?.bargroupgap,
        dragmode: false
      },
      {
        //this is where the configuration is defined
        responsive: true,
        displaylogo: false,
        scrollZoom: true,
        displayModeBar: false,
      });
    (document.getElementById('bar') as any).on('plotly_click', (data: any) => {
      this.barAction.emit(data);
    });
    (document.getElementById('bar') as any).on('plotly_legendclick', (data: any) => {
      return this.barData[0]?.legendClick ? data : false;
    });
    window.dispatchEvent(new Event('resize'));
  }

}

